<template>
  <div>
    <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
      <document-action-header :title="$t('Comments')" @on-close-click="onCloseClick">
        <template slot="actionTemplate">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="add" v-if="permissions.commentCreate">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Add') }}</span>
          </v-tooltip>
        </template>
      </document-action-header>

      <v-card-text class="pa-2 py-1 overflow-y-auto overflow-x-hidden" style="max-height: 250px;">
        <v-row justify="center" align="center" v-if="commentList.length == 0 && !loading && permissions.commentCreate">
          <div class="text-center">
            <a link @click="add">
              {{ $t('Add') }}
              <v-icon>mdi-plus</v-icon>
            </a>
          </div>
        </v-row>

        <template v-for="comment in commentList">
          <CommentItem
            :comment="comment"
            :canEdit="permissions.commentUpdate"
            :canDelete="permissions.commentDelete"
            v-bind:key="comment.id"
            @on-edit-comment="onEdit"
            @on-remove-comment="onRemove"
          />
        </template>
      </v-card-text>
    </v-card>
    <comment-modal :ref="modalKey" @on-comment-saved="onSaved" />
  </div>
</template>

<script>
import DocumentActionHeader from '@/components/search/results/list/item/actions/DocumentActionHeader';
import CommentItem from '@/components/search/results/list/item/actions/comment/CommentItem';
import CommentModal from '@/components/search/results/list/item/actions/comment/CommentModal';
import CommentService from '@/services/CommentService';
import Comment from '@/ecm/models/search/results/list/Comment';

export default {
    name: 'CommentList',
    components: {
        DocumentActionHeader,
        CommentItem,
        CommentModal
    },
    props: {
        documentId: {
            type: Number,
            required: true
        },
        permissions: {
            type: Object,
            required: true,
        },
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            commentList: [],
            loading: false,
            modalKey: 'modalComment'
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        }
    },
    methods: {
        onCloseClick() {
            this.$emit('on-close-click');
        },
        onSaved() {
            this.loadData();
        },
        onRemove(commentId) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-warning',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel')
            }).then(res => {
                if (res == 1) {
                    CommentService.remove(commentId).then(result => {
                        if (result) {
                            this.loadData();
                        }
                    });
                }
            });
        },
        onEdit(comment) {
            this.modalInstance.edit(comment);
        },
        add() {
            this.modalInstance.new(this.documentId);
        },
        loadData() {
            this.loading = true;
            CommentService.getList(this.documentId).then(data => {
                this.commentList = data.map(function(dto) {
                    return new Comment(dto);
                });
                this.loading = false;
                this.$emit('on-comments-updated', data.length);
            });
        }
    }
};
</script>